import { SchemaWithClient } from '../types/SchemaWithClient';
import { Client } from '../services/Client';
import { NumberField } from '../components/Table/fields/NumberField';
import { TextField } from '../components/Table/fields/TextField';
import { DateField } from '../components/Table/fields/DateField';
import { SelectField } from '../components/Table/fields/SelectField';
import { enumItems } from './enumItems';
import { SPTextField } from '../components/Table/fields/SPTextField';
import { SPDateField } from '../components/Table/fields/SPDateField';
import { SPSelectField } from '../components/Table/fields/SPSelectField';
import { SPNumberField } from '../components/Table/fields/SPNumberField';
import { CustomFieldForServicePrice } from '../components/Table/fields/CustomFieldForServicePrice';
import { BooleanField } from '../components/Table/fields/BooleanField';
import { SPBooleanField } from '../components/Table/fields/SPBooleanField';
import { RichTextField } from '../components/Table/fields/RichTextField';
import { SPRichTextField } from '../components/Table/fields/SPRichTextField';
import {SPSelectWithOutAutocomplete} from "../components/Table/fields/SPSelectWithOutAutocompleteField";

export const service: SchemaWithClient<any> = {
  name: 'Services',
  pluralName: 'Services',
  tabs: [
    {
      id: 1,
      label: 'General',
      name: 'general',
    },
  ],
  columns: {
    name: {
      name: 'Name',
      required: true,
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
      collapseHeader: true,
    },
    sp_name: {
      name: 'SP Name',
      required: true,
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    service_provider: {
      name: 'Service Provider',
      fieldRenderer: SelectField.tableAdapter(enumItems.serviceProvider),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(
        enumItems.serviceProvider
      ),
      url: enumItems.serviceProvider.client.getAllPath,
      tempSchema: enumItems.serviceProvider,
      switchboard: true,
    },
    price_refresh_date: {
      name: 'Price Refresh Date',
      fieldRenderer: DateField,
      slidePaneFieldRenderer: SPDateField,
      fieldType: 'date',
    },
    valid_from: {
      name: 'Valid From',
      fieldRenderer: DateField,
      slidePaneFieldRenderer: SPDateField,
      fieldType: 'date',
      collapseHeader: true,
    },
    valid_to: {
      name: 'Valid To',
      fieldRenderer: DateField,
      slidePaneFieldRenderer: SPDateField,
      fieldType: 'date',
      collapseHeader: true,
    },
    service_type: {
      name: 'Service Type',
      fieldRenderer: SelectField.tableAdapter(enumItems.serviceType),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(enumItems.serviceType),
      url: enumItems.serviceType.client.getAllPath,
      tempSchema: enumItems.serviceType,
      switchboard: true,
      collapseHeader: true,
    },

    currency: {
      name: 'Currency',
      fieldRenderer: SelectField.tableAdapter(enumItems.currency),
      slidePaneFieldRenderer: SPSelectWithOutAutocomplete.tableAdapter(enumItems.currency),
      url: enumItems.currency.client.getAllPath,
      tempSchema: enumItems.currency,
      switchboard: true,
      editOnlyByAdminOrTcFinance: true
    },
    unit_price: {
      name: 'Unit Cost Net',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'float',
       editOnlyByAdminOrTcFinance: true
    },
    vat: {
      name: 'VAT',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'float',
       editOnlyByAdminOrTcFinance: true
    },
    unit_price_gross: {
      name: 'Unit Cost Gross',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'float',
       editOnlyByAdminOrTcFinance: true
    },
    /*  group_price: {
      name: 'Group Price',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'float',
    },*/
    service_price: {
      name: 'Variable Costs',
      fieldRenderer: CustomFieldForServicePrice,
      slidePaneFieldRenderer: CustomFieldForServicePrice,
      fieldType: 'custom',
      editOnlyByAdminOrTcFinance: true
    },
    staff_required: {
      name: 'Staff Required',
      fieldRenderer: BooleanField,
      slidePaneFieldRenderer: SPBooleanField,
      fieldType: 'boolean',
    },
    dont_send_prices: {
      name: "Don't Send Prices",
      fieldRenderer: BooleanField,
      slidePaneFieldRenderer: SPBooleanField,
      fieldType: 'boolean',
    },
    includes_notes: {
      name: 'Includes',
      fieldRenderer: RichTextField,
      slidePaneFieldRenderer: SPRichTextField,
      fieldType: 'textarea',
    },
    id: {
      name: 'ID',
      required: true,
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      readOnly: true,
    },
  },
  client: new Client('/services'),
};
